/** @param {string} title @param {string} body */
function fieldHint(title, body) {
    return `${title}\n\n${body}`
}

/**
 * Shown on each class date editor (DevExtreme `hint` + native `inputAttr.title` on hover).
 * Use {@link classDateEditorOptions} on dxDateBox items.
 */
export const CLASS_DATE_FIELD_HINTS = {
    dateStart: fieldHint(
        'Overall date start',
        'Overall window for the class, including booking and study.'
    ),
    dateEnd: fieldHint(
        'Overall date end',
        'Overall window for the class, including booking and study.'
    ),
    bookingStart: fieldHint(
        'Booking start',
        'When enrolment booking is allowed. Booking may open before study starts and can continue after study begins. Booking end must fall within the overall end date.'
    ),
    bookingEnd: fieldHint(
        'Booking end',
        'When enrolment booking is allowed. Booking may open before study starts and can continue after study begins. Booking end must fall within the overall end date.'
    ),
    termStart: fieldHint('Study start', 'When instruction begins (class start).'),
    termEnd: fieldHint('Study ends', 'When instruction finishes (class completes).'),
}

/** @param {'dateStart'|'dateEnd'|'bookingStart'|'bookingEnd'|'termStart'|'termEnd'} fieldKey */
export function classDateEditorOptions(fieldKey) {
    const hint = CLASS_DATE_FIELD_HINTS[fieldKey]
    return {
        displayFormat: 'shortDate',
        type: 'date',
        pickerType: 'calendar',
        useMaskBehavior: true,
        hint,
        inputAttr: { title: hint },
    }
}
